import { I18nProvider } from '@lingui/react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { FormTranslationsProvider } from '../-components/form-translations-provider';
import { useStartDonationCount } from './-components/donation-count';

export const Route = createFileRoute('/new')({
	component: RouteComponent,
});

function RouteComponent() {
	// Request-scoped Lingui instance from router context — see www/route.tsx.
	const { i18n } = Route.useRouteContext();
	// The live-donations count belongs to the whole visit: started here, it keeps running across
	// pages, so the odometer on Solutions reflects the time spent anywhere on the site.
	useStartDonationCount();
	return (
		<I18nProvider i18n={i18n}>
			<FormTranslationsProvider>
				<Outlet />
			</FormTranslationsProvider>
		</I18nProvider>
	);
}
